<div class="text-surface-500">
  <p class="mb-6">Your subscription is no longer active, this means:</p>
  <p>
    <i class="pi pi-times text-red-600"></i>
    You can't:
  </p>
  <ul class="list-disc ml-6 mb-4">
    <li>Apply to new lotteries</li>
    <li>Make changes to your profile</li>
    <li>Contact support</li>
  </ul>
  <p>
    <i class="pi pi-check text-green-600"></i>
    You can:
  </p>
  <ul class="list-disc ml-6">
    <li>Follow up on your old applications</li>
  </ul>

  <div class="flex flex-row justify-center mt-6">
    <homey-submit-button size="small" severity="info" [submitFunction]="submit" submitButtonLabel="Re-subscribe"></homey-submit-button>
  </div>
</div>


